import { editUsers } from "../roles";

export const userColumns = (
  user,
  storeEntireRow,
  showDisplayModal,
  showEditModal,
  showAlert,
  storeUserId
) => {
  const columns = [
    {
      name: "Id",
      cell: (row) => row["id"],
      selector: 'id',
      sortable: true
    },
    {
      name: "First name",
      cell: (row) => row["firstName"],
    },
    {
      name: "Last name",
      cell: (row) => row["lastName"],
    },
    {
      name: "Username",
      cell: (row) => row["username"],
    },
    {
      name: "Phone",
      cell: (row) => row["phoneNumber"],
      sortable: true,
      selector: 'phoneNumber'
    },
    {
      name: "Email",
      cell: (row) => row["emailAddress"],
    },
    {
      name: "Location",
      cell: (row) => {
        const locations = row.locations && row.locations[0];
        return locations
          ? `${locations[0]?.name}
          ${locations.length === 1 ? "" : ","}
          ${locations[1] ? locations[1]?.name + "," : ""}
          ${locations[2] ? locations[2]?.name + "," : ""}
          ${locations[3] ? locations[3]?.name + "," : ""}
          ${locations[4] ? locations[4]?.name : ""}`
          : null;
      },
    },
    {
      name: "status",
      cell: (row) => row["status"].name,
    },
    {
      name: user?.roles?.some((role) => role.id === editUsers) ? (
        <div className='d-flex justify-content-end'>Actions</div>
      ) : null,
      cell: (row) => (
        <div className='d-flex' style={{ gap: 20 }}>
          {user?.roles?.some((role) => role.id === editUsers) && (
            <>
              <i
                className='fa fa-eye'
                aria-hidden='true'
                style={{
                  cursor: "pointer",
                  color: "#124db1",
                  fontWeight: 700,
                }}
                onClick={() => {
                  storeEntireRow(row);
                  showDisplayModal("display");
                }}
              />
              <i
                className='fa fa-pen'
                style={{ color: "#124db1", cursor: "pointer" }}
                onClick={() => {
                  storeEntireRow(row);
                  showEditModal(true);
                }}
              />
              <i
                className='fa fa-trash'
                style={{ color: "#8f250d", cursor: "pointer" }}
                onClick={() => {
                  showAlert(true);
                  storeUserId(row.id);
                }}
              />
            </>
          )}
        </div>
      ),
    },
  ];
  return columns;
};
